export const getIsCarregandoIndicadorEmpresa =
  (state) => state.indicadorEmpresa.isCarregandoIndicadorEmpresa
export const getIsSavingIndicadorEmpresa = (state) => state.indicadorEmpresa.isSaving
export const getAnoCarregado = (state) => state.indicadorEmpresa.anoCarregado
